import { Injectable } from '@angular/core';
import { uniq } from 'lodash-es';
import { vendor_products } from './tech-intel-vendor-product-data.service';
import { BehaviorSubject, combineLatest, Observable, of, Subscriber } from 'rxjs';
import { TechIntelCategoryDataService } from './tech-intel-category-data.services';
import { TechIntelVendorProductDataService } from './tech-intel-vendor-product-data.service';
import { TreeviewItem } from '../../../shared/components/tree-view/treeview-item';
import { environment } from '../../../../environments/environment';
import { TechIntelData } from '../../../results/sidebar/services/techintel-data.sevice';
import { tap } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})


export class TechIntelCategory {
    categoryTree = [];
    vendorProductList : Array<{ vendor: string, product: string }> = [];
    techIntelCategoryData: TreeviewItem<string>[] = [];
    techIntelSettings:any = {};
    private technographicsProductsListSubject = new BehaviorSubject<{ productsList: Array<{ vendor: string, product: string }>, categoryList: TreeviewItem<string>[] }>({
        productsList: null,
        categoryList: null
    });
    public readonly technographicsProductsListStatus$ = this.technographicsProductsListSubject.asObservable();
    dynamicTechnographics = environment.dynamicTechnographics;

    private techIntelSettingsSubject = new BehaviorSubject<void>(null);
    private categoriesFromRequest: any[] = [];

    constructor(
        private techIntelCategoryDataService: TechIntelCategoryDataService,
        private techIntelVendorProductDataService: TechIntelVendorProductDataService,
        private techintelService: TechIntelData,
    ) { }

    public vendors() {
        const vendorProducts = !this.dynamicTechnographics ? vendor_products : this.vendorProductList;
        const vendorNames = vendorProducts?.map((item) => {
            return item.vendor;
        });

        const sortedAndUnique = uniq(vendorNames).sort();

        return sortedAndUnique;
    }

    public products() {
        const vendorProducts = !this.dynamicTechnographics ? vendor_products : this.vendorProductList;
        const productNames = vendorProducts?.map((item) => {
            return item.product;
        });
        const sortedAndUnique = uniq(productNames).sort();

        return sortedAndUnique;
    }
    public mainCategories() {
        /* const mainCategoryNames = TechIntelCategoryData1.map(function (item) {
            return item.category;
        });

        const sortedAndUnique = uniq(mainCategoryNames).sort();

        return sortedAndUnique; */
    }

    public subCategories(mainCategory) {
       /*  const filteredCategories = TechIntelCategoryData1.filter(function (item) {
            return (item.category === mainCategory);
        });
        const subCategoryNames = filteredCategories.map(function (item) {
            return item.sub_category;
        });
        const sortedAndUnique = uniq(subCategoryNames).sort();

        return sortedAndUnique; */
    }
    public nodify(categoryName, selection, mainSelected) {
      /*   return new TreeviewItem({
            'value': categoryName,
            'text': categoryName,
            'checked': (selection.indexOf(categoryName) >= 0) || mainSelected,
            'collapsed': true,
            'children': []
        }); */
    }
    public buildCategoryTree(selectedCategories, selectedSubCategories) {
        /* const mainCategory = this.mainCategories();
        const result = chain(this.mainCategories())
            .map((item) => {
                return this.nodify(item, selectedCategories, false);
            })
            .forEach((node) => {
                const subCategoriesNode = this.subCategories(node.value);
                node.children = map(subCategoriesNode, (key, value) => {
                    return this.nodify(key, selectedSubCategories, node.checked);
                });

                const nodeSelectionCount = filter(node.children, function (item) {
                    return item.checked;
                }).length;
                node.collapsed = (nodeSelectionCount === 0 || nodeSelectionCount === node.children.length);

            }).value();

        this.categoryTree = clone(result); */
    }

    init(): Observable<boolean> {
        if (this.categoriesFromRequest?.length || this.vendorProductList?.length || this.techIntelSettings?.length) {
            return of(true);
        }

        return new Observable<boolean>((subscriber: Subscriber<boolean>) => {
            combineLatest([
                this.techIntelCategoryDataService.getTechIntelCategoryData(),
                this.techIntelVendorProductDataService.getTechIntelVendorProductData(),
                this.techintelService.getTechIntelSavedSettingsHttp(),
            ]).subscribe(([techIntelCategoryData, techIntelVendorProductData, techIntelSavedSettings]) => {
                this.handleTechIntelCategoryDataResponse(techIntelCategoryData);
                this.handleTechIntelVendorProductDataResponse(techIntelVendorProductData);
                this.handleTechIntelSavedSettingsHttpResponse(techIntelSavedSettings);
                subscriber.next(true);
                subscriber.complete();
            }, () => {
                subscriber.next(true);
                subscriber.complete();
            });
        });
    }

    private handleTechIntelCategoryDataResponse(response) {
        this.categoriesFromRequest = response.categories;
        this.createTree();
        this.technographicsProductsListSubject.next({
            productsList: this.vendorProductList,
            categoryList: this.techIntelCategoryData
        });
    }

    private handleTechIntelVendorProductDataResponse(response) {
        this.vendorProductList = response.products;
        this.technographicsProductsListSubject.next({
            productsList: this.vendorProductList,
            categoryList: this.techIntelCategoryData
        });
    }

    private handleTechIntelSavedSettingsHttpResponse(response) {
        this.techIntelSettings = response["response"];
    }

    createTree(filter?: string[]): void {
            const categoriesList = this.categoriesFromRequest;
            this.techIntelCategoryData = [];
            categoriesList?.forEach(element => {
                let subcatData = [];
                element.subCategories.forEach(subcat => {
                    if (!filter || !Array.isArray(filter) || !filter.length ||
                        filter.includes(subcat)) subcatData.push({ text: subcat, value: '', checked: false })
                })
                let categoryData = new TreeviewItem({
                    text: element.category, value: '', checked: false, collapsed: true, children: subcatData
                })
                if (!filter || !Array.isArray(filter) || !filter.length ||
                    filter.includes(element.category) || subcatData.length) this.techIntelCategoryData.push(categoryData);
            });
    }

    getTechIntelSettingsEvent(): Observable<void> {
        return this.techIntelSettingsSubject.asObservable();
    }

    emitTechIntelSettingsEvent() {
        this.techIntelSettingsSubject.next();
    }

    getFavorites(favorite: string): string[] {
        return [...(this.techIntelSettings[favorite] || [])];
    }

    getTechnographicsProductsVendorsList(): { productsList: Array<{ vendor: string, product: string }>, categoryList: TreeviewItem<string>[] } {
        return this.technographicsProductsListSubject.getValue();
    }

}
